/** Dia a dia → Guias: a Central de guias. Fatia 3a: a Caixa de entrada (o painel e as ações em lote vêm na 3b). */
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CaixaGuias } from '../telas/guias/caixa';

const Busca = z.object({ aba: z.enum(['caixa']).optional() });
export const Route = createFileRoute('/_app/guias')({ validateSearch: Busca, component: Guias });

function Guias() {
  return (
    <>
      <div className="topbar"><div><h1>Guias</h1><div className="sub">Caixa de entrada: solte os PDFs e o sistema encaixa cada guia na tarefa certa do cliente — o que não bater fica aqui para você resolver</div></div></div>
      <div className="conteudo"><CaixaGuias /></div>
    </>
  );
}
